const React = require('react')
const { useState, useCallback } = require('react')
const { useHistory } = require('react-router-dom')
const { Input, InputGroup, Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { useSearch } = require('@hooks')

const searchIcon = require('@assets/icons/searchWhite.svg')
require('@styles/layouts/header/searchBox.header.css')

const SearchBox = () => {
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { handleSearch } = useSearch()

    const [searchValue, setSearchValue] = useState('')

    const onHandleSearch = useCallback(() => {
        const route = handleSearch(searchValue)
        history.push(`/${network.name}/${route}`)
    }, [searchValue, network, handleSearch, history])

    const onHandleEnter = useCallback(
        e => {
            if (e.key === 'Enter') {
                const route = handleSearch(searchValue)
                history.push(`/${network.name}/${route}`)
            }
        },
        [searchValue, network, handleSearch, history]
    )

    const handleInputChange = useCallback(e => {
        setSearchValue(e.target.value)
    }, [])

    const handlePaste = useCallback(e => {
        e.preventDefault()
        const pastedText = e.clipboardData.getData('text')
        setSearchValue(pastedText)
    }, [])

    return (
        <InputGroup className='header-search-wrapper'>
            <Input
                className='form-control search-input'
                placeholder='Search by Address / Txn Hash / Block  / Token'
                onKeyDown={onHandleEnter}
                onChange={handleInputChange}
                onPaste={handlePaste}
                value={searchValue}
            />
            <Button
                className={`header-search-icon-wrapper ${network.name}-search-icon-wrapper`}
                onClick={onHandleSearch}
            >
                <img src={searchIcon} className='header-search-icon' alt='Search' />
            </Button>
        </InputGroup>
    )
}

module.exports = { SearchBox }
